<template>
    <div id="emailContainer" class="email-selection-container">
        <p class="breadcrumb">
            <button @click="goBack">< Back</button>
        </p>
        <div class="header-container">
            <div class="copy-container mobile">
                <p class="main-title">Enter Recipient information</p>
            </div>
            <div class="product-container">
                <div class="gift-container selected" >
                    <img class="green-check" src="https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"/>
                    <img class="main-image lazyload" :src="selectedCollection | getProductImage">
                    <p>{{ selectedCollection.title }}</p>
                </div>
            </div>
            <div class="copy-container">
                <p class="main-title desktop">Enter Recipient information</p>
                <p class="main-subtitle small">Send just one or in bulk by uploading a spreadsheet.</p>
            </div>
        </div>
        <div class="main-container">
            <div class="first-container">
                <div class="directions-container">
                    <p class="directions-title">Bulk Upload Recipients <img alt="bulk" src="https://cdn.shopify.com/s/files/1/1363/8433/files/bulk_icon_2df806c7-c557-455f-8022-c5d2d99b64a9.svg?v=1720467802"/></p>
                    <ol class="desktop">
                        <li><p>First, <a href="https://cdn.shopify.com/s/files/1/1363/8433/files/Happy_Box_GOC_Recipient_Email_Address_Template.xlsx?v=1683313367" class="shipping-instructions" download target="_blank"><img src="https://cdn.shopify.com/s/files/1/1363/8433/files/DOWNload.svg?v=1732720359" alt="download" width="20" height="20"/> Download the template</a> and fill it out</p></li>
                        <li><p>When complete, <label :for="'file'"><img src="https://cdn.shopify.com/s/files/1/1363/8433/files/upload_0c7b58b6-04e9-4bca-85b8-66b522cde950.svg?v=1732720359" alt="upload" width="20" height="20"/> Upload your .csv</label> the table below will populate with your information.</p></li>
                        <li><p>Make any adjustments you might need below.</p></li>
                    </ol>
                    <ol class="mobile">
                        <li><p>First, <a href="https://cdn.shopify.com/s/files/1/1363/8433/files/Happy_Box_GOC_Recipient_Email_Address_Template.xlsx?v=1683313367" class="shipping-instructions" download target="_blank"><img src="https://cdn.shopify.com/s/files/1/1363/8433/files/DOWNload.svg?v=1732720359" alt="download" width="20" height="20"/> Download the template</a></p></li>
                        <li><p>When complete, <label :for="'file'"><img src="https://cdn.shopify.com/s/files/1/1363/8433/files/upload_0c7b58b6-04e9-4bca-85b8-66b522cde950.svg?v=1732720359" alt="upload" width="20" height="20"/> Upload your .csv</label></p></li>
                        <li><p>Your information will populate in the table below. Review and adjust as needed!</p></li>
                    </ol>
                    <input :id="'file'" class="file-uploader" type="file" @change="fileChange" />
                </div>
            </div>
            <div class="recipients-container">
                <div class="qty-selection-container">
                    <p class="recipients-main-title">Manually Upload Recipients<img src="https://cdn.shopify.com/s/files/1/1363/8433/files/assitance.svg?v=1718205326"/></p>
                    <div class="content-container">
                        <div class="input-qty-container">
                            <p class="title">Enter Number of Recipients</p>
                            <input min="1" @change="validateQty" v-model="emailQty" type="number">
                        </div>
                        <div class="checkbox-container">
                            <label for="multiples">I want different notification dates for my recipients</label>
                            <input id="multiples" v-model="multipleNotificationDate" type="checkbox"/>
                        </div>
                    </div>
                </div>
                <p class="red-alert" v-if="showAlert">{{ redAlertCopy }}</p>
                <div v-for="(recipient,i) in recipientList" :key="i" class="recipient" :class="[i % 2 == 0 ? 'odd' : 'even']">
                    <p class="recipient-title">Recipient {{ i + 1}}:</p>
                    <div class="email-inputs-container">
                        <div class="input-container">
                            <p>Email</p>
                            <input v-model="recipient.email" placeholder="Email address" type="email"/>
                        </div>
                        <div class="input-container">
                            <p>First Name</p>
                            <input v-model="recipient.firstName" placeholder="First name" type="string"/>
                        </div>
                        <div class="input-container">
                            <p>Last Name</p>
                            <input v-model="recipient.lastName" placeholder="Last name" type="string"/>
                        </div>
                        <div class="input-container">
                            <p>From</p>
                            <input v-model="recipient.from" placeholder="Sender name" type="string"/>
                        </div>
                        <div v-if="multipleNotificationDate" class="input-container">
                            <p>Notification Date</p>
                            <datepicker :format="formatDate" :disabledDates="disabledDates" placeholder="Notification Date" v-model="recipient.notificationDate"></datepicker>
                        </div>
                    </div>
                    <img @click="removeRow(i)" class="remove lazyload" src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" />
                </div>
            </div>
            <p @click="addRecipient" class="add">ADD RECIPIENT +</p>
        </div>
        <div class="sticky-container">
            <button @click="submitEmailQty" v-if="!didSubmit && emailQty == 1" class="happybox-button green border">{{emailQty}} Recipients. Next: Enter Email Address</button>
            <button @click="submitEmailQty" v-else-if="!didSubmit && emailQty > 1" class="happybox-button green border">{{emailQty}} Recipients. Next: Enter Email Address</button>
            <button v-else @click="nextStep" class="happybox-button green border">Next: Customize Your Email</button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as XLSX from "xlsx";
import pako from 'pako';
import * as yup from 'yup';
import Datepicker from 'vuejs-datepicker';
import Swal from 'sweetalert2/dist/sweetalert2.js';
export default {
    components:{
        Datepicker
    },
    data(){
        return{
            emailQty: 1,
            didSubmit: true,
            recipientList: [{email:"",firstName: "",lastName: "",from:"", notificationDate: null}],
            emailFile: null,
            showAlert: false,
            disabledDates: {
                to: new Date(new Date().setDate(new Date().getDate()-1))
            }
        }
    },
    computed:{
        ...mapGetters([
            'selectedCollection',
            'emailFileData',
            'addressQty'
        ]),
        multipleNotificationDate: {
            get(){return this.$store.state.multipleNotificationDate},
            set(value){
                this.$store.commit('setMultipleNotificationDate', value );
            }
        },
        collectionPrice(){
            return parseInt(this.selectedCollection.variants[0].price)
        },
        isValidEmail(){
            let isValid = true;
            let schema = yup.object({
                firstName: yup.string().trim().required("First Name Required"),
                lastName: yup.string().trim().required("Last Name Required"),
                email: yup.string().trim().matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,"Please enter a valid email").required("Email required"),
            })
            if(this.multipleNotificationDate){
                var d = new Date();
                d.setDate(d.getDate() - 1);
                schema = yup.object({
                    firstName: yup.string().trim().required("First Name Required"),
                    lastName: yup.string().trim().required("Last Name Required"),
                    email: yup.string().trim().matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,"Please enter a valid email").required("Email required"),
                    notificationDate: yup.date().required("Notification Date Required").min(d,"Notification Date must be valid")
                })
            }
            let arraySchema = yup.array().of(schema);
            try{
                arraySchema.validateSync(this.recipientList);
            }
            catch(error){
                isValid = false;
            }
            
            return isValid;
        },
        redAlertCopy(){
           return "Please provide the following information to continue: Recipient(s)' information";
        }
    },
    methods:{
        goBack(){
            this.$emit('changepage', false );
        },
        submitEmailQty(){
            this.didSubmit = true;
            setTimeout(function(){
                var objDiv = document.getElementById("emailContainer");
                objDiv.scrollIntoView(false);
            }, 100);
        },
        addRecipient(){
            this.emailQty++;
            this.validateQty();
        },
        nextStep(){
            if(this.isValidEmail == false){
                this.validateRecipients();
                return;
            }
            this.$store.commit("setAddressQty",this.emailQty);
            let jsonData = JSON.stringify(this.recipientList);
            var compressed_uint8array = pako.gzip(jsonData);
            this.emailFile = btoa(String.fromCharCode.apply(null, compressed_uint8array));
            this.$store.commit("setEmailFileData",this.recipientList);
            this.$store.commit("setEmailFile",this.emailFile);
            this.$emit('changepage',true);
        },
        fileChange(event){
            this.file = event.target.files ? event.target.files[0] : null;
            event.target.value = '';
            if (this.file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    /* Parse data */
                    const bstr = e.target.result;
                    const wb = XLSX.read(bstr, { type: 'binary' });
                    /* Get first worksheet */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    /* Convert array of arrays */
                    this.skipHeaders(ws);
                    const data = XLSX.utils.sheet_to_json(ws,{header: ["firstName","lastName", "email","date" ,"from"], skipHeader: true});
                    this.readXlsAddresses(data);
                }

                reader.readAsBinaryString(this.file);
            }
        },
        skipHeaders(ws){
            var range = XLSX.utils.decode_range(ws['!ref']);
            range.s.r = 1; // <-- zero-indexed, so setting to 1 will skip row 0
            ws['!ref'] = XLSX.utils.encode_range(range);
        },
        readXlsAddresses(data){
            if(data.length < 1)
                return
            let invalidRows = [];
            let schema = yup.object({
                firstName: yup.string().trim().required("First Name Required"),
                lastName: yup.string().trim().required("Last Name Required"),
                email: yup.string().trim().matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,"Please enter a valid email").required("Email required"),
            });
            for(let [i,row] of data.entries()){
                if(row.email)
                    row.email = row.email.trim();
                try{
                    schema.validateSync(row);
                }
                catch(error){
                    invalidRows.push(`Row ${i+1}: ${error.message}`);
                    continue;
                }
            }
            if(invalidRows.length > 0){
                this.alertInvalidFile(invalidRows);
                return;
            }
            let file = data.map((x) => {
                if(x.date){
                    if( typeof x.date === 'string'){
                        x.notificationDate = this.removeTime(new Date(x.date));
                    }
                    else
                        x.notificationDate = this.excelDateToJSDate(x.date);
                }
                return x
            });
            this.multipleNotificationDate = file.some(x => x.notificationDate);
            this.recipientList = file;
            this.emailQty = file.length;
        },
        validateQty(){
            if(this.emailQty < 1){
                this.emailQty = 1;
            }
            var newQty = this.emailQty - this.recipientList.length;
            if(newQty > 0){
                for(let i = 1; i <= newQty; i++){
                    this.recipientList.push({email:"",firstName: "",lastName: "",from:""})
                }
            }
            else{
                this.recipientList = this.recipientList.slice(0,this.recipientList.length + newQty);
            }
        },
        removeRow(index){
            if(this.recipientList.length > 1){
                this.recipientList.splice(index, 1);
                this.emailQty = this.recipientList.length;
            }
        },
        excelDateToJSDate(serial){
            return this.removeTime(new Date(Date.UTC(0, 0, serial)));
        },
        removeTime(date = new Date()) {
            return new Date(
                date.getFullYear(),
                date.getMonth(),
                date.getDate()
            );
        },
        formatDate(date){
            return date.toLocaleString("en-US").split(",")[0];
        },
        alertInvalidFile(rows){
            let alertText = `<p class="title">Please fix the following errors:</p><ul style="list-style: inside;">`
            alertText += rows.map((x) => {
                return `<li  style="list-style: inside;">${x}</li>`
            }).join('');
            Swal.fire({
                iconHtml: `<img src="https://cdn.shopify.com/s/files/1/1363/8433/files/error_icon_2a88e148-df0e-480c-85b8-89b7d9d6e5ba.svg?v=1741881886" class="alert-icon"/>`,
                html: alertText,
                confirmButtonText: 'Go Back and Resubmit',
                customClass:{
                    container:"swal-custom-container",
                    popup: "swal-custom-popup-3",
                    title:"swal-title",
                    confirmButton: "happybox-button green border",
                },
                buttonsStyling: false,
            });
        },
        validateRecipients(){
            let invalidRows = [];
            let schema = yup.object({
                firstName: yup.string().trim().required("First Name Required"),
                lastName: yup.string().trim().required("Last Name Required"),
                email: yup.string().trim().matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,"Please enter a valid email").required("Email required"),
            });
            if(this.multipleNotificationDate){
                var d = new Date();
                d.setDate(d.getDate() - 1);
                schema = yup.object({
                    firstName: yup.string().trim().required("First Name Required"),
                    lastName: yup.string().trim().required("Last Name Required"),
                    email: yup.string().trim().matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,"Please enter a valid email").required("Email required"),
                    notificationDate: yup.date().required("Notification Date Required").min(d,"Notification Date must be valid")
                })
            }
            for(let [i,row] of this.recipientList.entries()){
                if(row.email)
                    row.email = row.email.trim();
                try{
                    schema.validateSync(row);
                }
                catch(error){
                    invalidRows.push(`Row ${i+1}: ${error.message}`);
                    continue;
                }
            }
            if(invalidRows.length > 0){
                this.alertInvalidFile(invalidRows);
                return;
            }
        }
    },
    mounted() {
        if(this.emailFileData && this.emailFileData.length > 0){
            this.recipientList = this.emailFileData;
        }
        if(this.addressQty && this.addressQty > 1){
            this.emailQty = this.addressQty;
        }
    },

}
</script>

<style>
    .input-container input{
        width: 100%;
        height: unset !important;
        padding: 5px !important;
        font-size: 1.15vw;
        border-radius: 8px !important;
        box-shadow: 0 0 2px #0000004d;
    }

    .input-container input::placeholder {
        font-size: 1vw;
    }

    .input-container input{
        font-size: 16px;
    }

    .input-container input::placeholder {
        font-size: 12px;
    }
</style>

<style scoped>

    .mobile{
        display: none;
    }

    .email-selection-container{
        background: linear-gradient(#E7E5FD 0, #FEFAF7 50%, #FFFDF9 100%);
        padding: 0% 15% 10%;
        position: relative;
    }

    .header-container{
        width: 100%;
        display: flex;
        padding-top: 5%;
        justify-content: center;
        align-items: center;
        position: relative;
        gap: 5%;
    }

    .header-container .copy-container{
        width: 60%;
    }

    .header-container .product-container{
        width: 15%;
    }

    .gift-container{
        width: 100%;
        margin-right: 2%;
        margin-bottom: 5%;
        border-radius: 4px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: white;
    }

    .gift-container.selected{
        border: 1px solid #16A34A;
    }

    .gift-container p {
        font-size: 1vw;
        font-weight: 700;
        padding: 5% 0;
        margin: unset;
        text-align: center;
    }

    .green-check{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }

    .gift-container .main-image{
        width: 100%;
        box-sizing: border-box;
        cursor: pointer;
        position: relative;
    }

.main-title{
    font-size: 3vw;
    margin: unset;
    color: #0f0c38;
    width: 100%;
    padding-bottom: 1%;
    line-height: .9;
    font-family: Founders Grotesk, sans-serif;
    font-weight: 600;
}

.main-subtitle{
    font-family: "karla",sans-serif;
    font-size: 1.3vw;
    margin: unset;
    line-height: 1.2;
    text-align: left;
    color: #0f0c38;
}

.footer-copy{
    font-family: "karla";
    font-size: 1vw;
    line-height: 1.2;
    text-align: center;
    color: #0f0c38;
}
  

  .download-template{
    border-radius: 30px;
    background: #F7F9FD;
    padding: 1% 3%;
    color: #0f0c38;
    font-size: 1.15vw;
    line-height: 1.2;
    text-decoration: underline;
  }

  .qty-selection-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 2% 5%;
  }

  .qty-selection-container .content-container{
    width: 100%;
    display: flex;
    align-items: center;
  }

  .checkbox-container{
    display: flex;
    gap: 5px;
  }

  .checkbox-container label{
    font-size: 1vw;
    color: #0f0c38;
  }

  .email-container{
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 3%;
    border-top: 0.5px solid gray;
  }

    .email-container button{
        margin: 3% 0%;
    }
    .directions-container{
        width: 100%;
    }
  
    .directions-container p{
        margin: unset;
        color: #0f0c38;
    }
  
    .directions-title,.recipients-main-title{
        font-weight: 700;
        font-size: 1.5vw;
        line-height: 1.2;
        padding-bottom: 1%;
        display: flex;
        align-items: center;
        gap: 5px;
        width: 100%;
        margin: unset
    }

    .directions-title img{
        width: 3%;
    }

    .recipients-main-title img{
        width: 2%;
    }
  
    .directions-subtitle{
      font-size: 1.15vw;
      line-height: 1.2;
      padding-bottom: 1%;
    }

    .directions-container ol{
    margin:0 0 0rem 2rem;
  }

  .directions-container ol li{
    list-style: inherit;
    padding: unset;
    color: #0f0c38;
    font-size: 1.15vw;
    margin-bottom: 0.5rem;
  }

  .directions-container ol li p{
    display: flex;
    align-items: center;
    gap: 3px;
  }

  .directions-container ol li img,.directions-container label img{
    width: 15px;
    height: auto;
  }

  .directions-container ol li a,.directions-container label{
    color: #a01adb;
    border: 1.5px solid #a01adb;
    display: flex;
    gap: 5px;
    align-items: flex-end;
    padding: 1% 2%;
    border-radius: 100px;
    font-weight: bold;
    line-height: 1;
  }

    .directions-container label img{
        height: 1.15vw;
    }
  
    .directions-subtitle a{
        color: #a01adb;
        text-decoration: underline;
        font-weight: 700;
    }
  
    .file-uploader{
      height: unset !important;
      border: unset !important;
      margin: unset;
      padding: 1% 0% !important;
      font-size: 1.2vw;
      color: #0f0c38;
      display: none;
    }

  .file-upload-container{
    font-size: 1.2vw;
    color: #0f0c38;
    width: 100%;
  }

  .file-uploader{
    height: unset !important;
    border: unset !important;
    margin: unset;
    padding: 1% 0% !important;
    font-size: 1.2vw;
    color: #0f0c38;
    width: 70%;
    display: none;
  }

  .recipients-container{
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 5%;
    background-color: white;
    border-radius: 8px;
    border: 1px solid lightgray;
  }

  .recipient{
    padding: 2% 5%;
    border-radius: 8px;
    position: relative;
  }

  .recipient.odd{
    border-bottom: 1px solid lightgray;
    border-top: 1px solid lightgray;
    background-color: #f7f7f7;
  }

  .recipient.odd:first-child{
    border-top: unset;
  }

  .recipient.odd:last-child{
    border-bottom: unset
  }

  .recipient .remove{
    position: absolute;
    right: -1.5%;
    height: 25%;
    top: -12%;
    cursor: pointer;
    background-color: white;
  }

  .recipients-container .recipient-title{
    margin: unset;
    font-weight: bold;
    color: #0f0c38;
    line-height: 1.2;
    font-size: 1.4vw;
  }

  .email-inputs-container{  
    display: flex;
    width: 100%;
    gap: 15px;
  }

  .input-container{
    width: 23%;
  }

  .input-container p{
    font-weight: bold;
    font-size: 1vw;
    line-height: 1.6;
    margin: 0;
    color: #0f0c38;
  }

  .main-container{
    width: 100%;
    display: flex;
    padding-top: 5%;
    justify-content: space-between;
    flex-direction: column;
  }

  .main-container .first-container{
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 2% 5%;
    box-shadow: 0 0px 2px rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    background-color: white
  }

  .input-qty-container{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
  }

  .input-qty-container .title{
    font-size: 1vw;
    color: #0f0c38;
    margin-bottom: 0;
  }

    .input-qty-container img{
        width: 5%;
    }

    .input-qty-container input{
        width: 15%;
        height: 2em !important;
        min-height: 2em;
    }

    .sticky-container{
      position: fixed;
      bottom: 0%;
      width: 100%;
      display: flex;
      justify-content: center;
      background-color: #fafafacc;
      left: 0;
    }

    .sticky-container .happybox-button{
      margin: 1% 0%;
      padding: 1% 10%;
    }

    .red-alert{
        text-align: center;
        width: 100%;
        font-size: 1.15vw;
        color: red;
    }

    .breadcrumb{
		color: #0f0c38;
        text-decoration: underline;
        position: absolute;
        top: 0%;
        left: 5%;
        z-index: 1;
	}

	.breadcrumb > * {
		color: #a01adb;
        font-weight: bold;
		text-decoration: underline;
	}

    .add{
        cursor: pointer;
        color: #a01adb;
        text-decoration: underline;
        font-weight: 700;
        font-size: 1.5vw;
        width: 100%;
        text-align: center;
        margin-top: 1rem;
    }

  @media only screen and (max-device-width: 767px){

    .desktop{
        display: none;
    }

    .mobile{
        display: block;
    }

    .main-title{
        font-size: 8vw;
        width: 100%;
        line-height: 1.2;
        text-align: center;
        margin-top: 1rem
    }

    .main-title span{
        font-style: italic;
    }

    .main-subtitle,.footer-copy{
        font-size: 3.5vw;
        margin: 4% 0%;
        padding: 0% 5%;
        line-height: 1.4;
    }

    .main-subtitle.small{
        width: 100%;
        text-align: center;
        padding: unset;
        margin-top: unset;
    }

    .main-container{
        flex-direction: column;
        align-items: center;
    }

    .main-container .product-container{
        margin: unset;
        width: 50%;
    }

    .input-qty-container .title{
        font-size: 3vw;
    }

    .input-qty-container img{
        width: 6%;
    }

    .recipients-container{
        margin-bottom: 10%;
    }

    .preview-container .recipient-title{
        font-size: 3.5vw;
    }

    .shipped-table th,.shipped-table tbody{
        font-size: 3vw;
    }
    

    .happybox-button{
        margin: 7% 0%;
        width: 80%;
        padding: 2% 0%;
    }

    .download-template{
        text-decoration: underline;
        font-size: 3vw;
        padding: 2% 5%;
    }

    .file-uploader{
        font-size: 4vw;
        width: 80%;
    }

    .email-inputs-container{  
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .input-container{
        width: 100%;
    }

    .input-container p{
        font-size: 3vw;
    }

    .sticky-container{
      width: 100%;
      position: fixed;
      bottom: 0%;
      text-align: center;
      background-color: #fafafacc;
      z-index: 1;
      display: flex;
      justify-content: center;
      gap: 5px;
      align-items: center;
      flex-direction: column;
      padding: 5%;
    }

    .sticky-container .happybox-button.orange{
      width: 90%;
      padding: 2%;
      font-size: 4vw;
    }

    .red-alert{
        font-size: 3.5vw;
    }

    .main-container .first-container{
        flex-direction: column;
        align-items: center;
        background-color: unset;
        box-shadow: unset;
        padding: unset;
        gap: 20px;
        background-color: #f7f7f7;
        margin-bottom: 1rem;
    }

    .qty-selection-container{
        max-width: 100%;
        width: 100%;
        padding: 2% 5%;
    }

    .gift-container p{
        font-size: 3vw;
    }

    .checkbox-container label{
        font-size: 3vw;
    }

    .email-selection-container{
        padding: 0% 5% 30%;
    }

    .directions-container{
        max-width: 100%;
        background-color: #f7f7f7;
        box-shadow: 0 0 2px #0000004d;
        border-radius: 8px;
        width: 100%;
        padding: 2% 5%;
        display: flex;
        gap: 5px;
        flex-direction: column;
        align-items: flex-start;
    }

    
    .directions-title, .recipients-main-title{
        font-size: 4.5vw;
        text-align: center;
    }

    .directions-subtitle{
        font-size: 3vw;
    }

    .directions-title img{
        width: 7%;
    }

    .recipients-main-title img{
        width: 5%;
    }

    .directions-container label{
        font-size: 3.5vw;
    }

    .directions-container label img{
        height: 3.5vw;
    }

    .breadcrumb{
      top: 0.5%;
    }

    .header-container{
        flex-direction: column;
    }

    .header-container .copy-container{
        width: 100%;
    }

    .header-container .product-container{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 1rem;
    }

    .gift-container{
        margin-right: unset;
        width: 40%;
    }

    .recipients-container .recipient-title{
        font-size: 4.5vw;
    }

    .recipient{
        padding: 5%;
    }

    .recipient .remove{
        right: 5%;
        width: 7%;
        height: unset;
        top: 4%;
    }

    .qty-selection-container .content-container{
        align-items: flex-start;
        flex-direction: column;
    }

    .recipient.odd{
        background-color: white;
    }

    .recipients-container{
        background-color:#f7f7f7;
    }

    .add{
        font-size: 3.5vw;
        margin: unset;
    }

    .directions-container ol li{
      font-size: 3.5vw;
    }

    .directions-container ol li p{
      flex-wrap: wrap;
    }
  }

</style>